'use client';

import { carouselClassNames } from 'components/shared/Card/styles';
import { BaseCarousel } from 'components/shared/Carousel/BaseCarousel';
import { useBreakpoint } from 'hooks/useBreakpoints';
import { Sys } from 'libs/contentful/props';
import { useState, useEffect, PropsWithChildren } from 'react';
import { Colorways } from 'types/constants';
import { CarouselOptions } from 'types/sharedComponents';
import { liveUpdateAttrs } from 'libs/contentful/utils';

interface ResourceSliderProps extends PropsWithChildren {
  wrapSlider: boolean;
  numberOfCards: number;
  color: Colorways;
  sys?: Sys;
}
const ResourceSlider = ({ children, sys, wrapSlider, color, numberOfCards }: ResourceSliderProps) => {
  const [isClient, setIsClient] = useState(false);
  const { isBelowSm } = useBreakpoint('sm');
  const hasTwoRows = isBelowSm && wrapSlider;
  const totalSlides = hasTwoRows ? Math.ceil(numberOfCards / 2) : numberOfCards;

  useEffect(() => {
    setIsClient(true);
  }, []);

  const options: CarouselOptions = {
    align: 'start',
    loop: false,
    breakpoints: {
      '(min-width: 1024px)': { active: false },
      '(max-width: 750px)': { slidesToScroll: wrapSlider ? 2 : 1 },
    },
    slidesToScroll: 1,
    containScroll: false,
  };

  return (
    isClient && (
      <BaseCarousel
        totalItems={totalSlides}
        carouselClassName={carouselClassNames(color)}
        carouselPaginationClassName="mt-8"
        carouselContentClassName="w-full pt-2"
        showPaginationThreshold={1}
        carouselOpts={options}
        aria-label="Resources slider"
        aria-roledescription="Resources slider"
        {...liveUpdateAttrs(sys?.id, 'content')}>
        {children}
      </BaseCarousel>
    )
  );
};

export default ResourceSlider;
